import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CREATION_METHOD_TIMELINE } from 'constants/comments';
import { ROLLOUT_AT_MENTION_COMMENT } from 'constants/featureFlag';
import { videoPlayerExitCommentMode } from 'creators/videoPlayer';
import { secondsToVideoTS } from 'utilities/time';

import { useFlagIsActivated } from 'hooks/featureFlag';

import CommentInputGroup from '../../comment-input-group';

import styles from './styles.module.less';

const CommentBar = () => {
  const dispatch = useDispatch();
  const isMentionComponentEnabled = useFlagIsActivated({
    flag: ROLLOUT_AT_MENTION_COMMENT,
    activationValues: [true],
  });
  const onExitCommentMode = () => {
    dispatch(videoPlayerExitCommentMode());
  };

  const placeholder = isMentionComponentEnabled
    ? 'Leave a comment or add others with @'
    : 'Leave a comment';

  const barClasses = classNames(styles.commentBar, 'theme-dark');
  const currentTime = useSelector(state => state.video_player.current_time);

  function submitButtonText() {
    return (
      <span>
        Comment at{' '}
        <span className={styles.timeText}>
          {secondsToVideoTS(Math.round(currentTime))}
        </span>
      </span>
    );
  }

  return (
    <div className={barClasses}>
      <CommentInputGroup
        allowOneLine={true}
        creationMethod={CREATION_METHOD_TIMELINE}
        drawCancel="true"
        grabFocus="true"
        inputSize="small"
        onCancel={onExitCommentMode}
        onSubmit={onExitCommentMode}
        placeholder={placeholder}
        submitButtonText={submitButtonText()}
        isCommentBar={true}
      ></CommentInputGroup>
    </div>
  );
};

export default CommentBar;
